export default __webpack_public_path__ + "static/media/index.a1287a35.less";